export enum BraintreePlanType {
	MONTHLY = "monthly",
	YEARLY = "yearly",
}
